import { useField } from 'formik';
import React, { FC, useState } from 'react';
import { Form } from 'react-bootstrap';

import Group from '../Group';
import { useChange } from '../hooks';
import { FormSelectFieldProps } from '../types';

const Select: FC<FormSelectFieldProps> = ({
  onLine,
  label,
  helpText,
  placeholder,
  onFocus,
  children,
  ...props
}: FormSelectFieldProps) => {
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const [{ name, value, onBlur }, { error, touched }] = useField(props);
  const handleChange = useChange(props);
  const isInvalid = Boolean(error) && touched;

  const handleFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onFocus) {
      // @ts-ignore
      onFocus(e);
    }
    setIsFocus(true);
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    onBlur(e);
    setIsFocus(false);
  };

  return (
    <Group
      name={name}
      controlId={name}
      label={label}
      error={error}
      isInvalid={isInvalid}
      onLine={onLine}
      isFocus={isFocus}
    >
      <Form.Control
        {...props}
        as="select"
        name={name}
        value={value?.toString()}
        isInvalid={Boolean(error) && touched}
        onChange={handleChange}
        // @ts-ignore
        onBlur={handleBlur}
        // @ts-ignore
        onFocus={handleFocus}
      >
        <option value="">{placeholder}</option>
        {children}
      </Form.Control>
    </Group>
  );
};

export default Select;
